import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.create";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.timers";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 Copyright (c) 2018 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Note: These tests rely on the following markup defined in /jest/jest-setup-file.js:
 <div id="root" data-app-container=""><div data-page-container=""></div></div>
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DOMPurify from 'dompurify';
import unique from '../../lib/unique-id/unique-id';
import { addAriaLivePoliteMessage as _addAriaLivePoliteMessage, addAriaLiveAssertiveMessage as _addAriaLiveAssertiveMessage, addAriaLiveAlertMessage as _addAriaLiveAlertMessage, removeAriaLivePoliteMessage as _removeAriaLivePoliteMessage, removeAriaLiveAssertiveMessage as _removeAriaLiveAssertiveMessage, removeAriaLiveAlertMessage as _removeAriaLiveAlertMessage } from '../../lib/store/aria-live/actions';

var AriaLiveMessage = /*#__PURE__*/function (_React$Component) {
  _inherits(AriaLiveMessage, _React$Component);

  var _super = _createSuper(AriaLiveMessage);

  function AriaLiveMessage() {
    var _this;

    _classCallCheck(this, AriaLiveMessage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      id: unique()
    });

    _defineProperty(_assertThisInitialized(_this), "announce", function () {
      var _this$props = _this.props,
          message = _this$props.message,
          ariaLive = _this$props['aria-live'],
          role = _this$props.role,
          addAriaLivePoliteMessage = _this$props.addAriaLivePoliteMessage,
          addAriaLiveAssertiveMessage = _this$props.addAriaLiveAssertiveMessage,
          addAriaLiveAlertMessage = _this$props.addAriaLiveAlertMessage;
      var id = _this.state.id;
      var cleanedMessage = DOMPurify.sanitize(message, {
        ALLOWED_TAGS: [],
        KEEP_CONTENT: true
      });

      if (ariaLive === 'polite') {
        setTimeout(function () {
          return addAriaLivePoliteMessage({
            id: id,
            message: cleanedMessage
          });
        }, 0);
      }

      if (ariaLive === 'assertive') {
        setTimeout(function () {
          return addAriaLiveAssertiveMessage({
            id: id,
            message: cleanedMessage
          });
        }, 0);
      }

      if (role === 'alert') {
        setTimeout(function () {
          return addAriaLiveAlertMessage({
            id: id,
            message: cleanedMessage
          });
        }, 0);
      }
    });

    return _this;
  }

  _createClass(AriaLiveMessage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.announce();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var message = this.props.message;

      if (message !== prevProps.message) {
        this.announce();
      }
    } // Note: The setTimeout usage below improves the odds that screen readers will detect the
    // changes rendered by AriaLiveAnnouncer. Updates to the DOM (like showing or hiding the working indicator)
    // appear to interfere with screen reader functionality

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this2 = this;

      var _this$props2 = this.props,
          ariaLive = _this$props2['aria-live'],
          role = _this$props2.role,
          clearOnUnmount = _this$props2.clearOnUnmount,
          removeAriaLivePoliteMessage = _this$props2.removeAriaLivePoliteMessage,
          removeAriaLiveAssertiveMessage = _this$props2.removeAriaLiveAssertiveMessage,
          removeAriaLiveAlertMessage = _this$props2.removeAriaLiveAlertMessage;

      if (clearOnUnmount === true || clearOnUnmount === 'true') {
        if (ariaLive === 'polite') {
          setTimeout(function () {
            return removeAriaLivePoliteMessage(_this2.state.id);
          }, 0);
        }

        if (ariaLive === 'assertive') {
          setTimeout(function () {
            return removeAriaLiveAssertiveMessage(_this2.state.id);
          }, 0);
        }

        if (role === 'alert') {
          setTimeout(function () {
            return removeAriaLiveAlertMessage(_this2.state.id);
          }, 0);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return AriaLiveMessage;
}(React.Component);

AriaLiveMessage.propTypes = {
  message: PropTypes.string.isRequired,
  clearOnUnmount: PropTypes.bool,
  'aria-live': PropTypes.string,
  role: PropTypes.string
};
AriaLiveMessage.defaultProps = {
  clearOnUnmount: true
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    addAriaLivePoliteMessage: function addAriaLivePoliteMessage(_ref) {
      var id = _ref.id,
          message = _ref.message;
      return dispatch(_addAriaLivePoliteMessage({
        id: id,
        message: message
      }));
    },
    addAriaLiveAssertiveMessage: function addAriaLiveAssertiveMessage(_ref2) {
      var id = _ref2.id,
          message = _ref2.message;
      return dispatch(_addAriaLiveAssertiveMessage({
        id: id,
        message: message
      }));
    },
    addAriaLiveAlertMessage: function addAriaLiveAlertMessage(_ref3) {
      var id = _ref3.id,
          message = _ref3.message;
      return dispatch(_addAriaLiveAlertMessage({
        id: id,
        message: message
      }));
    },
    removeAriaLivePoliteMessage: function removeAriaLivePoliteMessage(id) {
      return dispatch(_removeAriaLivePoliteMessage({
        id: id
      }));
    },
    removeAriaLiveAssertiveMessage: function removeAriaLiveAssertiveMessage(id) {
      return dispatch(_removeAriaLiveAssertiveMessage({
        id: id
      }));
    },
    removeAriaLiveAlertMessage: function removeAriaLiveAlertMessage(id) {
      return dispatch(_removeAriaLiveAlertMessage({
        id: id
      }));
    }
  };
};

export default connect(null, mapDispatchToProps)(AriaLiveMessage);